import React from 'react';
import { Trans } from 'react-i18next';

import Macaluso from '../../../shared/assets/Annalisa_Macaluso.jpg';
import Carluccio from '../../../shared/assets/Antonella_Carluccio.jpg';
import Rota from '../../../shared/assets/Emanuela_Rota.jpg';
import Rocchi from '../../../shared/assets/Federica_Rocchi.png';
import Bertario from '../../../shared/assets/Giulia_Bertario.jpg';
import Bellocchio from '../../../shared/assets/Riccardo_Bellocchio.jpg';
import Greco from '../../../shared/assets/Serena_Greco.png';
import Guglielmi from '../../../shared/assets/Stefano_guglielmi_2.jpg';
import Suttora from '../../../shared/assets/suttora.jpg';
import DellaPina from '../../../shared/assets/ANNA_DELLA_PINA.jpg';
import Cavalchino from '../../../shared/assets/FRANCESCA_CAVALCHINO.jpg';
import Portes from '../../../shared/assets/DALIS_PORTES.jpg';
import Mazziotti from '../../../shared/assets/Francesca_Mazziotti.jpg';
import Achilli from '../../../shared/assets/Martina_Achilli.jpg';

export const BOSS = [
  {
    size: 'big',
    bio: `Laurea in Scienze Politiche, Consulente del Lavoro iscritto,
                all’Ordine di Milano n°1852. Approfondita conoscenza della
                contrattualistica italiana e delle relazioni industriali.
              
                Docente presso enti pubblici e privati in materie giuridiche.
                Coordinatore del Centro Studi dell’Ordine dei Consulenti del
                Lavoro di Milano. Segretario dell’Ordine dei Consulenti del
                Lavoro di Milano.`,
    image: Bellocchio,
    name: 'RICCARDO BELLOCCHIO',
    job: 'Partner & Co-Founder',
  },
  {
    size: 'big',
    bio: `Laurea in economia, Consulente del Lavoro iscritto all’Ordine di,
                Milano n°1789. Vasta ed approfondita esperienza
                nell’amministrazione del personale e nelle relazioni
                industriali. Solida competenza in materia di international
                assigny e nella sociologia dell’ambiente di lavoro.
              
                Componente del Centro Studi dell’Ordine dei Consulenti del
                Lavoro di Milano. Relatore a numerosi convegni ed eventi
                formativi.`,
    image: Guglielmi,
    name: 'STEFANO GUGLIELMI',
    job: 'Partner & Co-Founder',
  },
];

export const COORDINATORS = [
  {
    size: 'small',
    image: Macaluso,
    name: 'ANNALISA MACALUSO',
    job: <Trans>Coordinator</Trans>,
  },
  {
    size: 'small',
    image: Greco,
    name: 'SERENA GRECO',
    job: <Trans>Coordinator</Trans>,
  },
  {
    size: 'small',
    image: Suttora,
    name: 'GABRIELE SUTTORA',
    job: <Trans>IT_manager</Trans>,
  },
];

export const COLLABORATORS = [
  {
    size: 'small',
    image: Carluccio,
    name: 'ANTONELLA CARLUCCIO',
    job: <Trans>Collaborator</Trans>,
  },
  {
    size: 'small',
    image: Rota,
    name: 'EMANUELA ROTA',
    job: <Trans>Collaborator</Trans>,
    position: 'center',
  },
  {
    size: 'small',
    image: Bertario,
    name: 'GIULIA BERTARIO',
    job: <Trans>Collaborator</Trans>,
  },
  {
    size: 'small',
    image: Cavalchino,
    name: 'FRANCESCA CAVALCHINO',
    job: <Trans>Collaborator</Trans>,
  },
  {
    size: 'small',
    image: DellaPina,
    name: 'ANNA DELLA PINA',
    job: <Trans>Collaborator</Trans>,
  },
  {
    size: 'small',
    image: Rocchi,
    name: 'FEDERICA ROCCHI',
    job: <Trans>Collaborator</Trans>,
  },
  {
    size: 'small',
    image: Mazziotti,
    name: 'FRANCESCA MAZZIOTTI',
    job: <Trans>Collaborator</Trans>,
  },
  {
    size: 'small',
    image: Achilli,
    name: 'MARTINA ACHILLI',
    job: <Trans>Collaborator</Trans>,
  },
  {
    size: 'small',
    image: Portes,
    name: 'DALIS PORTES',
    job: 'Office Manager',
  },
];
